/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'
import MwImport from './MwImport'
import BreakerImport from './BreakerImport'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import TurbinePoints from './TurbinePoints'
import BSECErrorCodeMap from './BSGGHWErrorCodeMap'
import CraneCreekImport from './CraneCreekImport'
import ForwardImport from './ForwardImport'
import BSGF from './BSGFImport'
import GHWP from './GHWPImport'

const CoreConatiner = ({ actionPermits, envConfig }) => {
  const mwImport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.MW_IMPORT_VIEWER,
          ScreenPermissions.MW_IMPORT_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const breakerImport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.BREAKER_IMPORT_VIEWER,
          ScreenPermissions.BREAKER_IMPORT_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceCraneCreek = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.CRANECREEK_IMPORT_ADMIN,
          ScreenPermissions.CRANECREEK_IMPORT_VIEWER,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceForwardImport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.FORWARD_IMPORT_ADMIN,
          ScreenPermissions.FORWARD_IMPORT_VIEWER,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceBSGF = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.BSGF_IMPORT_ADMIN,
          ScreenPermissions.BSGF_IMPORT_VIEWER,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceGHWP = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.GHWP_IMPORT_VIEWER,
          ScreenPermissions.GHWP_IMPORT_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceTurbinePoints = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.TURBINE_POINTS_IMPORT_ADMIN,
          ScreenPermissions.TURBINE_POINTS_IMPORT_VIEWER,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasInterfaceBSGFErrorCodeMap = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.BSGF_GHWP_ERROR_MAP_IMPORT_ADMIN,
          ScreenPermissions.BSGF_GHWP_ERROR_MAP_IMPORT_VIEWER,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <>
      {mwImport && <Route exact path="/mw-import" component={MwImport} />}
      {breakerImport && (
        <Route exact path="/breaker-import" component={BreakerImport} />
      )}
      {hasInterfaceTurbinePoints && (
        <Route exact path="/turbine-points" component={TurbinePoints} />
      )}
      {hasInterfaceBSGFErrorCodeMap && (
        <Route exact path="/bsgf-error-code-map" component={BSECErrorCodeMap} />
      )}
      {hasInterfaceCraneCreek && (
        <Route exact path="/crane-creek-import" component={CraneCreekImport} />
      )}

      {hasInterfaceForwardImport && (
        <Route exact path="/forward-import" component={ForwardImport} />
      )}
      {hasInterfaceBSGF && <Route exact path="/bsgf-import" component={BSGF} />}
      {hasInterfaceGHWP && <Route exact path="/ghwp-import" component={GHWP} />}
    </>
  )
}

export default CoreConatiner
